import { useState, useEffect } from 'react';
import CTEyeService from '../../services/CTEyeService';
import { UrlService } from '../../services';
import { useParams, useNavigate } from 'react-router-dom';
import { UploadSessionModel } from '../../data/entities';
import { ActiveUploadsSection, InspectionHistorySection } from './components';
import { POLL_ACTIVE_SESSION_MS } from './helper/pollingConfig';
import { useGaugeConfig } from './hooks';

export function CTEyeClientUploadSessions() {
  const urlParams = useParams();
  const id = UrlService.getParamValue('id', urlParams) ?? '0';
  const navigate = useNavigate();
  const gaugeConfig = useGaugeConfig(id);
  const service = new CTEyeService();

  const [activeSessions, setActiveSessions] = useState<UploadSessionModel[]>([]);
  const [historySessions, setHistorySessions] = useState<UploadSessionModel[]>([]);
  const [loadingActive, setLoadingActive] = useState(true);

  const loadSessions = async () => {
    try {
      const [activeResponse, historyResponse] = await Promise.all([
        service.getClientUploadSessionsOData(
          id,
          "$filter=(status eq 'Queued' or status eq 'InProgress') and uploadType ne 'LiveView'&$orderby=startDate desc&$expand=Inspection"
        ),
        service.getClientUploadSessionsOData(
          id,
          "$filter=(status eq 'Completed' or status eq 'Failed') and uploadType ne 'LiveView'&$orderby=endDate desc&$expand=Inspection"
        ),
      ]);

      if (activeResponse?.value) setActiveSessions(activeResponse.value);
      if (historyResponse?.value) setHistorySessions(historyResponse.value);
    } catch (error) {
      console.error('Error loading sessions:', error);
    } finally {
      setLoadingActive(false);
    }
  };

  useEffect(() => {
    document.getElementById('main-content')?.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    loadSessions();
    const interval = setInterval(loadSessions, POLL_ACTIVE_SESSION_MS);
    return () => clearInterval(interval);
  }, [id]);

  const handleViewResults = (session: UploadSessionModel) =>
    navigate(`/cteye/clients/${id}/inspections/${session.inspectionId}`);

  return (
    <div className="row justify-content-center">
      <div className="col-12 col-lg-10 col-xl-8">

        {/* Page Header */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-1">Imports In Progress</h5>
              <p className="text-muted mb-0 small">
                Track file upload progress &bull; Auto-refreshes every 2s
              </p>
            </div>
          </div>
        </div>

        <ActiveUploadsSection
          activeSessions={activeSessions}
          loadingActive={loadingActive}
          gaugeConfigResolver={() => gaugeConfig}
        />

        <InspectionHistorySection
          historySessions={historySessions}
          onViewResults={handleViewResults}
        />

      </div>
    </div>
  );
}

export default CTEyeClientUploadSessions;